module.exports = __webpack_public_path__ + "static/favicons/apple-touch-icon-72x72-b1092602b223fa0302b09059b3107ebd.png";